import cn from 'classnames';
import React from 'react';

import styles from './styles.module.scss';

const TableCell = ({
  fontSize,
  width,
  minWidth,
  right = false,
  style,
  center = false,
  column = false,
  className,
  inner = false,
  ...props
}) => (
  <div
    className={cn(
      styles.table_cell,
      right && styles.right_content,
      center && styles.center_content,
      column && styles.column,
      inner && styles.inner,
      className,
      props.styles,
    )}
    style={{ ...style, fontSize, width, minWidth: width }}
    {...props}
  >
    {props.children}
  </div>
);

export default TableCell;
